export default __webpack_public_path__ + "static/media/blog-img74.10e2ded4.jpg";